import { z } from "zod";
import { UserType } from "@/modules/auth/objects/userType";

export type QcUser = z.infer<typeof QcUserSchema>;
export const QcUserSchema = z.object({
  id_account: z.number().nullable(),
  access_id: z.string().nullable(),
  name: z
    .string()
    .nullable()
    .transform((value) => value ?? ""),
  lang_cd: z
    .string()
    .nullable()
    .transform((value) => value ?? "en"),
  icon: z
    .string()
    .nullable()
    .transform((value) => value ?? ""),
  user_type: z
    .enum([
      UserType.bot,
      UserType.bizAgency,
      UserType.bizStaff,
      UserType.bizGuest,
      UserType.intercom,
      UserType.broadcast,
      UserType.none,
    ])
    .nullable()
    .transform((value) => value ?? UserType.none),
  email: z.string().optional().nullable(),
  qr: z.string().nullable().optional(),
  activation_type: z.string().nullable(),
  notification_email: z
    .boolean()
    .nullable()
    .transform((value) => value ?? false),
  notification_push: z
    .boolean()
    .nullable()
    .transform((value) => value ?? false),
  is_official: z.boolean().nullable(),
  sign_up_at: z.string().nullable(),
  sandbox_type: z.string().nullable(),
  mode: z.string().nullable(),
  online_status: z.string().nullable(),
  created_at: z.string().nullable(),
  updated_at: z.string().nullable(),
});
